if (document.querySelector('.anchor-links')) {
  const anchorLinks = document.querySelectorAll('.anchor-links li a');

  anchorLinks.forEach(link => {
    link.addEventListener('click', function() {
      anchorLinks.forEach(item => {
        item.classList.remove('active');
      });

      this.classList.add('active');

    });
  });

  // Add 'active' class to the first link
  if (anchorLinks.length > 0) {
    anchorLinks[0].classList.add('active');
  }
}
